import { render, staticRenderFns } from "./carbon_oil.vue?vue&type=template&id=268024dc&scoped=true"
import script from "./carbon_oil.vue?vue&type=script&lang=js"
export * from "./carbon_oil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268024dc",
  null
  
)

export default component.exports